export enum CriteriaId {
  jev_playground = "jev_playground",
  bannedWords = "bannedWords",
  clause = "clause",
  contains_date = "contains_date",
  contains_name = "contains_name",
  endswith = "endswith",
  first_word = "first_word",
  indicated = "indicated",
  indicated_clause = "indicated_clause",
  spelling = "spelling",
  words_contain = "words_contain",
  pos = "pos",
  header = "header",
  nth_header = "nth_header",
  paragraph_alignment = "paragraph_alignment",
  paragraphs = "paragraphs",
  sentences = "sentences",
  manual = "manual",
}

export const allCriteria = [
  CriteriaId.bannedWords,
  CriteriaId.clause,
  CriteriaId.contains_date,
  CriteriaId.contains_name,
  CriteriaId.endswith,
  CriteriaId.first_word,
  CriteriaId.indicated,
  CriteriaId.indicated_clause,
  CriteriaId.spelling,
  CriteriaId.words_contain,
  CriteriaId.pos,
  CriteriaId.header,
  CriteriaId.nth_header,
  CriteriaId.paragraph_alignment,
  CriteriaId.paragraphs,
  CriteriaId.sentences,
  CriteriaId.manual,
  CriteriaId.spelling,
];

export const enum CriteriaIdOptionMapTypes {
  checkbox,
  select,
  multiselect,
  input,
}

export const CriteriaIdOptionsMap: Record<CriteriaId, CriteriaOptionMapType[]> =
  {
    [CriteriaId.jev_playground]: [],
    [CriteriaId.bannedWords]: [
      {
        key: "values",
        label: "Banned Words",
        type: CriteriaIdOptionMapTypes.multiselect,
      },
    ],
    [CriteriaId.clause]: [],
    [CriteriaId.contains_date]: [],
    [CriteriaId.contains_name]: [],
    [CriteriaId.endswith]: [
      {
        key: "values",
        label: "Ends With",
        type: CriteriaIdOptionMapTypes.multiselect,
      },
    ],
    [CriteriaId.first_word]: [
      {
        key: "type",
        label: "Type",
        type: CriteriaIdOptionMapTypes.select,
        options: ["all", "first"],
      },
      {
        key: "values",
        label: "Words to match",
        type: CriteriaIdOptionMapTypes.multiselect,
      },
    ],

    [CriteriaId.indicated]: [
      {
        key: "inferSubTypes",
        label: "Infer SubTypes?",
        type: CriteriaIdOptionMapTypes.checkbox,
      },
      {
        key: "types",
        label: "Types",
        type: CriteriaIdOptionMapTypes.select,
        options: [
          "topic",
          "dressUp",
          "decoration",
          "sentenceOpener",
          "bannedWords",
        ],
      },
      {
        key: "subTypes",
        label: "Sub Types",
        type: CriteriaIdOptionMapTypes.select,
        options: [
          "lyAdverb",
          "whoWhichClause",
          "strongVerb",
          "qualityAdjective",
          "clause",
          "becauseClause",
          "vocab",
          "subject",
          "prepositional",
          "ing",
          "clausal",
          "vss",
          "www.asia",
          "www.asia.b",
        ],
      },
    ],
    [CriteriaId.indicated_clause]: [
      {
        key: "types",
        label: "Types",
        type: CriteriaIdOptionMapTypes.select,
        options: [
          "topic",
          "dressUp",
          "decoration",
          "sentenceOpener",
          "bannedWords",
        ],
      },
      {
        key: "subTypes",
        label: "Sub Types",
        type: CriteriaIdOptionMapTypes.select,
        options: [
          "lyAdverb",
          "whoWhichClause",
          "strongVerb",
          "qualityAdjective",
          "clause",
          "becauseClause",
          "vocab",
          "subject",
          "prepositional",
          "ing",
          "clausal",
          "vss",
          "www.asia",
          "www.asia.b",
        ],
      },
    ],

    [CriteriaId.spelling]: [],
    [CriteriaId.words_contain]: [
      {
        key: "values",
        label: "Words to match",
        type: CriteriaIdOptionMapTypes.multiselect,
      },
    ],
    [CriteriaId.pos]: [
      {
        key: "values",
        label: "Parts of Speech",
        type: CriteriaIdOptionMapTypes.multiselect,
        options: [
          "ADJ",
          "ADP",
          "ADV",
          "AUX",
          "CCONJ",
          "DET",
          "INTJ",
          "NOUN",
          "NUM",
          "PART",
          "PRON",
          "PROPN",
          "PUNCT",
          "SCONJ",
          "SYM",
          "VERB",
          "X",
        ],
      },
    ],
    [CriteriaId.header]: [],
    [CriteriaId.nth_header]: [
      {
        key: "value",
        label: "Which header index?",
        type: CriteriaIdOptionMapTypes.input,
      },
    ],
    [CriteriaId.paragraph_alignment]: [
      {
        key: "values",
        label: "Paragraph Alignment",
        type: CriteriaIdOptionMapTypes.select,
        options: ["LEFT", "RIGHT", "CENTER"],
      },
    ],
    [CriteriaId.paragraphs]: [],
    [CriteriaId.sentences]: [],
    [CriteriaId.manual]: [],
  };

export type CriteriaOptionMapType = {
  key: string;
  label: string;
  type: CriteriaIdOptionMapTypes;
  options?: string[];
};
